export default __webpack_public_path__ + "static/media/icon-add-user-circle-solid.f0b7eec0.svg";